import React, { useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import "./App.css";
import Header from "./Components/Header/header";
import Home from "./Pages/Home/home";
import Movie from "./Pages/MovieDetail/moviedetail";
import Login from "./Pages/Login/login";
import { ImSad } from "react-icons/im";
import Register from "./Pages/Register/register";
import { onAuthStateChanged } from "firebase/auth";
import { auth } from "./utils/firebase";
import { useDispatch } from "react-redux";
import { addUser, removeUser } from "./utils/store/slice/userSlice";
import UsePopularMovies from "./customHooks/usePopularMovies";
import UseTopMovies from "./customHooks/useTopMovies";
import UseUpcomingMovies from "./customHooks/useUpcomingMovies";
import UseNowMovies from "./customHooks/useNowMovies";
import FavouriteMovies from "./Pages/Favourite Movies/favouriteMovies";

function App() {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  UsePopularMovies();
  UseTopMovies();
  UseUpcomingMovies();
  UseNowMovies();

  useEffect(() => {
    onAuthStateChanged(auth, (user) => {
      if (user) {
        const { uid, email, displayName } = user;
        dispatch(addUser({ uid: uid, email: email, displayName: displayName }));
        navigate("/browse");
      } else {
        dispatch(removeUser());
        navigate("/");
      }
    });
    // eslint-disable-next-line
  }, []);

  return (
    <>
      <Header />
      <Routes>
        <Route index element={<Home />}></Route>
        <Route path="browse" element={<Home />}></Route>
        <Route path="movie/:id" element={<Movie />}></Route>
        <Route path="favourite_movies" element={<FavouriteMovies />}></Route>
        <Route path="login" element={<Login />}></Route>
        <Route path="register" element={<Register />}></Route>
        <Route
          path="/*"
          element={
            <h1 style={{ fontSize: "5rem", marginTop: "3rem" }}>
              <ImSad />
              Error <br /> Page Not Found
            </h1>
          }
        ></Route>
      </Routes>
    </>
  );
}

export default App;
